import { useContext } from 'react';

import { FastGameContext } from './FastGameContext';

export function useFastGameCtx() {
  const ctx = useContext(FastGameContext);
  return ctx;
}
